import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './styles/Global.css'
import NavBar from './components/NavBar';
import Home from './pages/Home';
import Predict from './pages/Predict';
import Leaderboard from './pages/Leaderboard';
import Points from './pages/Points';
import Profile from './pages/Profile';
import Verification from './pages/Verification';
import ResetPassword from './pages/ResetPassword';
import SuperAdmin from "./pages/SuperAdmin";
import RequireAuth from "./components/RequireAuth";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Squads from "./pages/Squads";
import Rules from "./pages/Rules";

function App() {
    return (
        <>
            <Router>
                <NavBar />
                <ScrollToTop />

                <div className="page-content">
                    <Routes>
                        <Route path="/home" element={<Home />} />
                        <Route path="/predict" element={<Predict />} />
                        <Route path="/leaderboard" element={<Leaderboard />} />
                        <Route path="/points" element={<Points />} />
                        <Route path="/points/user/:username" element={<Points />} />
                        <Route path="/squads" element={<Squads />} />
                        <Route path="/rules" element={<Rules />} />
                        <Route path="/verification" element={<Verification />} />
                        <Route path="/forgot-password" element={<ResetPassword />} />
                        <Route path="/profile" element={
                            <RequireAuth> 
                                <Profile /> 
                            </RequireAuth>} 
                        />
                        <Route path="/super-admin" element={
                            <RequireAuth> 
                                <SuperAdmin /> 
                            </RequireAuth>} 
                        />

                        <Route path="/" element={<Navigate to="/predict" replace />} />
                        <Route path="*" element={<Navigate to="/predict" replace />} />
                    </Routes>
                </div>
            </Router>
            <Footer />
        </>
    );
}

export default App;
